import lazyWithRetry from 'tools/lazyWithRetry';

const component = lazyWithRetry(() => import(
	/* webpackChunkName: "ActivityCategoryListPage" */
	'pages/sales/PriceRevisionFormula/PriceRevisionFormulaListPage'));

export default [{ component, exact: true, path: '/price_revision_formulas' }];